import { Selector } from '@reduxjs/toolkit';

export interface Change<T, P> {
  previousState: T;
  currentState: T;
  parentChange: P;
}

export type Handler<C> = (change: C) => any;

export type SelectorChange<S extends Selector<any, any>> =
  S extends Selector<infer I, infer O> ? Change<O, Change<I, null>> : never;
export const selectorHandlerFactory =
  <S, R>(selector: Selector<S, R>, handler: Handler<SelectorChange<Selector<S, R>>>) =>
  (initialState: S) => {
    let previousState = selector(initialState);
    return (parentChange: Change<S, null>) => {
      const currentState = selector(parentChange.currentState);
      if (!Object.is(currentState, previousState)) {
        handler({ previousState, currentState, parentChange });
        previousState = currentState;
      }
    };
  };
